const styles = theme => ({
	
	root: {
		display: 'flex',
	},
	
	editIcon: {
		color: '#009AC9',
	},

	editIconDisabled: {
		color: '#C5C5C5',
	},

	checkIcon: {
		color: '#51B383',
	},
});

export default styles;